import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import ApexCharts from 'apexcharts';

const W55Graph = ({ state, fullscreenGraphs, setFullscreenGraphs }) => {
    const [zoomRange, setZoomRange] = useState(null);

    const commonOptions = {
        chart: {
            id: "W55Graph",
            type: "area",
            height: '100%',
            zoom: {
                enabled: true,
                type: "xy",
                autoScaleYaxis: false,
                allowMouseWheelZoom: false,
            },
            toolbar: {
                autoSelected: "zoom",
                tools: {
                    download: true,
                    selection: true,
                    zoom: true,
                    zoomin: true,
                    zoomout: true,
                    pan: true,
                    reset: true,
                    customIcons: [{
                        icon: '<i class="fa fa-expand"></i>',
                        index: 0,
                        title: 'Fullscreen',
                        class: 'custom-icon',
                        click: function (chart, options, e) {
                            setFullscreenGraphs(!fullscreenGraphs);
                        }
                    }]
                },
            },
            events: {
                zoomed: function (chartContext, { xaxis }) {
                    console.log("zoomed", xaxis)
                    setZoomRange({ min: xaxis.min, max: xaxis.max });
                },
                beforeResetZoom: function (chartContext, { xaxis }) {
                    ApexCharts.exec("W55Graph", "updateOptions", {
                        xaxis: { min: undefined, max: undefined },
                        yaxis: { min: undefined, max: undefined },
                    }, false, true);
                },
            },
        },
        toolbar: {
            show: true,
            tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true,
                customIcons: [{
                    icon: '<i class="fa fa-expand" ></i>',
                    index: 0,
                    title: 'Fullscreen',
                    class: 'custom-icon',
                    click: function (chart, options, e) {
                        setFullscreenGraphs(!fullscreenGraphs);
                    }
                }]
            },
        },
        dataLabels: {
            enabled: false, // Hide numbers on data points
        },
        markers: {
            size: 0, // Remove point markers
        },
        stroke: {
            curve: 'stepline',
            width: 2
        },
        colors: ['#FEB019'],
        fill: {
            type: 'gradient',
            gradient: {
                shadeIntensity: 1,
                inverseColors: false,
                opacityFrom: 0.5,
                opacityTo: 0,
                stops: [0, 90, 100]
            },
        },
        yaxis: {
            min: 0,
            max: 100,
            title: {
                text: 'W55 Tank Setpoint (%)',
                style: {
                    fontSize: '11px',
                    fontWeight: 400,
                    fontFamily: 'Helvetica, Arial, sans-serif',

                }
            },
        },
        xaxis: {
            type: 'datetime',
            labels: {
                datetimeUTC: false,  // This makes it use local time
                format: 'dd/MM/yyyy HH:mm',
                style: {
                    fontSize: '11px'
                },

            },
            tooltip: {
                formatter: function (val) {
                    return new Date(val).toLocaleString(); // Local time in tooltip
                }
            }
        },
        tooltip: {
            enabled: true,
            followCursor: true,    // Disable follow cursor
            intersect: false,       // Show tooltip even when not directly over point
            shared: true,           // Show all series in tooltip
            custom: undefined,      // Remove any custom tooltip
            fixed: {
                enabled: true,      // Enable fixed position
                position: 'topLeft', // Position the tooltip
                offsetX: 10,        // Add some horizontal offset
                offsetY: 10,        // Add some vertical offset
            },
            x: {
                format: 'dd MMM yyyy HH:mm'
            },
            marker: {
                show: true,
            },
            onDatasetHover: {
                highlightDataSeries: true,
            },
        },

    };



    return (
        <ReactApexChart
            options={{
                ...commonOptions,
                xaxis: {
                    ...commonOptions.xaxis,
                    ...(zoomRange && { min: zoomRange.min, max: zoomRange.max }),
                },
            }}
            series={state.series}
            type="area"
            height="100%"
            width="100%"
        />
    );
};

export default W55Graph;
